import { createContext, useContext } from 'react';

export const PortfolioProjectsContext = createContext();

export const usePortfolioProjectContext = () =>
  useContext(PortfolioProjectsContext);

export default PortfolioProjectsContext;
